import {
  Avatar,
  Box,
  Stack,
  Typography,
} from "@mui/material";

function MessagesProfileComponent({
  primaryText,
  secondaryText = "",
  time = "",
  chatDescriptionHeading = false,
  chatConservation = false,
  isMyMessage,
  avatar
}) {
  if (chatConservation) {
    if (chatDescriptionHeading) {
      return (
        <Stack direction="row" sx={{ gap: "12px", alignItems: "center" }}>
          <Avatar
            src={avatar || "/images/default-avatar.jpeg"}
            alt="Profile Picture"
            sx={{
              width: 42,
              height: 42,
              objectFit: "cover",
            }}
          />
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#000",
              }}
            >
              {primaryText}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontSize: "12px",
                color: "#4CAF50",
              }}
            >
              {secondaryText}
            </Typography>
          </Box>
        </Stack>
      );
    }

    return (
      <Stack
        direction="row"
        sx={{
          gap: "12px",
          alignItems: "flex-start",
          width: "100%",
          justifyContent: isMyMessage ? 'flex-end' : 'flex-start',
          mb: 2
        }}
      >
        {!isMyMessage && (
          <Avatar
            src={avatar || "/images/default-avatar.jpeg"}
            alt="Profile Picture"
            sx={{
              width: 32,
              height: 32,
              objectFit: "cover",
            }}
          />
        )}
        
        <Box
          sx={{
            maxWidth: '70%',
            bgcolor: isMyMessage ? '#1976d2' : '#f0f0f0',
            p: 2,
            borderRadius: isMyMessage 
              ? '20px 20px 0px 20px'
              : '20px 20px 20px 0px',
            position: 'relative',
            alignSelf: isMyMessage ? 'flex-end' : 'flex-start'
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: isMyMessage ? '#ffffff' : '#666',
              fontSize: "14px",
              lineHeight: "20px",
            }}
          >
            {secondaryText}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: isMyMessage ? '#e3f2fd' : '#666',
              fontSize: "11px",
              position: 'absolute',
              bottom: -18,
              [isMyMessage ? 'right' : 'left']: 2,
              opacity: 0.8
            }}
          >
            {primaryText}
          </Typography>
        </Box>

        {isMyMessage && (
          <Avatar
            src={avatar || "/images/default-avatar.jpeg"}
            alt="Profile Picture"
            sx={{
              width: 32,
              height: 32,
              objectFit: "cover",
            }}
          />
        )}
      </Stack>
    );
  }

  // For chat list items
  return (
    <Stack direction="row" sx={{ gap: "12px", alignItems: "center" }}>
      <Avatar
        src={avatar || "/images/default-avatar.jpeg"}
        alt="Profile Picture"
        sx={{
          width: 48,
          height: 48,
          objectFit: "cover",
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "15px",
            lineHeight: "18.15px",
            pb: "4px",
            fontWeight: chatDescriptionHeading ? "600" : "400",
          }}
        >
          {primaryText}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#8c8c8c",
            fontSize: "14px",
            lineHeight: "17px",
          }}
        >
          {secondaryText}
        </Typography>
      </Box>
      {time && (
        <Typography
          variant="body2"
          sx={{
            color: "#8c8c8c",
            fontSize: "12px",
          }}
        >
          {time}
        </Typography>
      )}
    </Stack>
  );
}

export default MessagesProfileComponent;
